module.exports = __webpack_public_path__ + "static/media/6.2_preview.f2199974.png";